import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    isRemoteAvailable: false,
    locations: [],
    placeIds: [],
    roles: [],
    contractTypes: [],
    noticePeriodInDays: '',
    salary: '',
    resume: null,
    resumeFile: '',
    skills: [],
    talentPools: [],
    mundoCryptoCer: ''
  },
  getters: {
    formData: state => {
      const contractTypes = state.contractTypes.map((type) => {
        switch (type) {
          case 'Permanent': return 'permanent'
          case 'Contract': return 'contract'
          case 'Voluntary': return 'voluntary'
          case 'Freelance': return 'freelance'
          case 'Bounty': return 'bounty'
          case 'Equity': return 'equity'
        }
      })
      return {
        locations: state.locations,
        roles: state.roles,
        contracts: contractTypes,
        noticePeriod: parseInt(state.noticePeriodInDays),
        salary: parseInt(state.salary),
        skills: state.skills,
        resume: state.resume,
        isRemoteAvailable: state.isRemoteAvailable,
        talentPools: state.talentPools.length > 0 ? state.talentPools.map(talentPool => talentPool.id) : []
      }
    },
    resumeName: state => {
      if (state.resume) {
        return 'db-cv.' + state.resume.split('.').pop()
      } else {
        return null
      }
    },
    resumeUrl: state => {
      return state.resume
    }
  },
  mutations: {
    setRemoteLocation (state, remote) {
      state.isRemoteAvailable = remote
    },
    setLocations (state, locations) {
      state.locations = locations
    },
    setRoles (state, roles) {
      state.roles = roles
    },
    setContractTypes (state, types) {
      state.contractTypes = types.map(_.capitalize)
    },
    setNoticePeriodInDays (state, days) {
      state.noticePeriodInDays = days
    },
    setSalary (state, salary) {
      state.salary = salary
    },
    setSkills (state, skills) {
      state.skills = skills
    },
    setResume (state, resume) {
      state.resume = resume
    },
    setTalentPools (state, talentPools) {
      state.talentPools = talentPools
    },
    setMundoCryptoCer (state, mundoCryptoCer) {
      state.mundoCryptoCer = mundoCryptoCer
    }
  },
  actions: {
    loadWithProfile ({ commit }, profile) {
      const locationTitles = profile.locations || []
      const placeIds = profile.placeIds || []
      const roles = profile.roles || []
      const contractTypes = profile.contracts || []
      const noticePeriodInDays = profile.noticePeriod || ''
      const salary = profile.salary || ''
      const skills = profile.skills || []
      const resumeUrl = profile.resumeUrl || ''
      const remote = profile.isRemoteAvailable || false
      const talentPools = profile.hasOwnProperty('talentPools') ? profile.talentPools : []
      const mundoCryptoCer = profile.mundoCryptoCer || ''
      const locations = _.zip(locationTitles, placeIds).map(x => ({
        title: x[0],
        placeId: x[1]
      }))
      commit('setLocations', locations)
      commit('setRoles', roles)
      commit('setContractTypes', contractTypes)
      commit('setNoticePeriodInDays', noticePeriodInDays)
      commit('setSalary', salary)
      commit('setSkills', skills)
      commit('setResume', resumeUrl)
      commit('setRemoteLocation', remote)
      commit('setTalentPools', talentPools)
      commit('setMundoCryptoCer', mundoCryptoCer)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jobseeker-form.js